import { render, staticRenderFns } from "./TableCellTypeRelationshipManyToMany.vue?vue&type=template&id=78405554&scoped=true"
import script from "./TableCellTypeRelationshipManyToMany.vue?vue&type=script&lang=js"
export * from "./TableCellTypeRelationshipManyToMany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78405554",
  null
  
)

export default component.exports